import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchMonitorSnapshot } from '@apis/monitor';
import { useAppDispatch } from '@store/hooks';
import { applySnapshot, setSnapshotStatus } from '@store/slices/monitor.slice';

export function useMonitorSnapshot(siteId: string | null) {
  const dispatch = useAppDispatch();
  const query = useQuery({
    queryKey: ['monitor', 'snapshot', siteId],
    queryFn: ({ signal }) => fetchMonitorSnapshot(siteId!, signal),
    enabled: !!siteId,
  });

  useEffect(() => {
    if (query.isFetching && !query.data) {
      dispatch(setSnapshotStatus('loading'));
    } else if (query.isError) {
      dispatch(setSnapshotStatus('error'));
    } else if (query.data) {
      dispatch(applySnapshot(query.data));
    }
  }, [query.data, query.isFetching, query.isError, dispatch]);

  return query;
}
